import React from "react"
import AcTag from "~/components/atoms/AcTag"

interface Props {
  status: number
  size?: "sm" | "lg" | "fix"
}

export default function TaskTag(props: Props) {
  const { status = 0, size } = props

  const tasks = {
    0: {
      label: "契約準備中",
      color: "danger",
    },
    10: {
      label: "重説準備中",
      color: "waiting",
    },
    20: {
      label: "重説準備完了",
      color: "waiting",
    },
    21: {
      label: "IT重説完了",
      color: "itHeavy",
    },
    30: {
      label: "契約完了",
      color: "success",
    },
    40: {
      label: "契約完了",
      color: "info",
    },
    50: {
      label: "キャンセル",
      color: "disabled",
    },
    60: {
      label: "下書き",
      color: "draft",
    },
  }

  return (
    <AcTag size={size} type={tasks[status]?.color}>
      {tasks[status]?.label}
    </AcTag>
  )
}
